<div class="blog-card-container">
    <div class="blog-card">
        <div class="blog-image-col">
            <img [src]="blog.blogMainImage || './assets/images/blog-default.png'" [alt]="blog.title" class="blog-image" (error)="setDefaultImage($event)">
        </div>

        <div class="blog-content-col">
            <div class="col-header">
                <button class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                    <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                </button>
            </div>
            <h3 class="blog-title">{{ blog.title }}</h3>
            <p class="blog-description">
                {{ blog.excerpt | slice:0:200 }}{{ blog.excerpt.length > 200 ? '...' : '' }}
            </p>

            <div class="blog-footer">
                <div class="status-badge">
                    <span class="status-dot" [class.public]="blog.visible" [class.private]="!blog.visible"></span>
                    <span class="status-text">{{ blog.visible ? 'Public' : 'Privé' }}</span>
                </div>

                <div class="creation-date">
                    {{ blog.createdAt | date: 'dd/MM/yyyy HH:mm' }}
                </div>
            </div>
        </div>
    </div>

    <div class="popup-menu" *ngIf="menuOpen">
        <div class="arrow"></div>
        <ul>
            <li>
                <img src="./assets/images/icons/details.png" alt="View"> Details
            </li>
            <li (click)="editBlog()">
                <img src="./assets/images/icons/edit.png" alt="Edit"> Modifier
            </li>
            <li (click)="toggleVisibility()">
                <img src="./assets/images/icons/eye.png" alt="Visibility"> {{ blog.visible ? 'Rendre privé' : 'Rendre public' }}
            </li>
            <li (click)="confirmDelete()" class="delete-item">
                <img src="./assets/images/icons/trash.png" alt="Delete"> Supprimer
            </li>
        </ul>
    </div>
</div>

<div class="confirmation-modal-overlay" *ngIf="showDeleteModal">
    <div class="confirmation-modal">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir supprimer l'article <br><strong>"{{ blog.title }}"</strong> ?</p>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="deleteBlog()">Supprimer</button>
        </div>
    </div>
</div>